import React, { Component } from 'react'

// import './Card.css';
import './Card-Structure.css';
import './Card.css';

import Config from './Config';
import Helper from './Helper';

export default class Card extends Component {
    constructor () {
        super ();

        this.onMouseDown = this.onMouseDown.bind (this);
        this.onDoubleClick = this.onDoubleClick.bind (this);
    }

    onMouseDown (event) {
        if (!this.props.onMouseDown) { return; }
        this.props.onMouseDown ( {event, card: this.props} )
    }

    onDoubleClick (event) {
        if (!this.props.onDoubleClick) { return; }
        this.props.onDoubleClick ({ event, card: this.props })
    }

    createPreyIcon (data, index) {
        let className = 'card-food' + ' ' + 't' + data.trophicLevel
        return (
            <div className={className} key={index}>
                <span>{data.name}</span>
            </div>
        )
    }

    getOpacity () {
        let opacity = 1;

        if ('opacity' in this.props) { opacity = this.props.opacity }

        return opacity;
    }

    getApexPredatorDom () {
        return (
            <section className="card-wrapper">
                <header>
                    {this.props.isProtected === true &&
                        <div className="card-protection"></div>
                    }
                </header>
                <div className="card-title">
                    <span>
                        {this.props.name}
                    </span>
                </div>
                <div className="card-image"> </div>
                <footer>
                    { this.props.diet.map (this.createPreyIcon) }
                </footer>
            </section>
        )
    }

    getSpeciesDom () {
        let wrapperClassName = 'card-wrapper';
        if (this.props.isScared === true) {
            wrapperClassName += ' ' + 'scared';
        }

        let protectedSpecies = (this.props.protectedSpeciesName === this.props.name)

        let name = this.props.name;
        let needsIce = this.props.needsIce;

        switch (name) {
            case Config.cards.phytoPlankton.name:
                name = 'Phyto-plankton';
                break;
            case Config.cards.iceAlgea.name:
                needsIce = 0;
                break;
        }

        let opacity = this.getOpacity ();

        let style = { opacity }

        return (
            <section style={style} className={wrapperClassName}>
                <header style={style}>
                    {protectedSpecies === true &&
                        <div style={style} className="card-protection"></div>
                    }
                    <div style={style} className="card-symbol">
                        <span style={style}>{this.props.symbol}</span>
                    </div>
                    { needsIce > 0 &&
                        <div style={style} className="card-ice-value">
                            <span>{needsIce}</span>
                        </div>
                    }
                </header>
                <div style={style} className="card-title">
                    <span style={style}>
                        {name}
                    </span>
                </div>
                <div style={style} className="card-image"> </div>
                <footer style={style}>
                    { this.props.diet.map (this.createPreyIcon) }
                </footer>
            </section>
        )
    }

    getWorldEventDom () {
        let symbol = this.props.symbol

        // if (symbol === '-2') { symbol = -2 + this.props.iceDestroyed }
        if (symbol === '-2') { symbol = '-2 ice' }
        if (this.props.name === Config.cards.rapidSeaIceLoss.name) { symbol = '-3 ice' }

        let footer = this.props.footer;

        if (!footer) { footer = 'Event' }

        if (this.props.name === Config.cards.overHarvesting.name) { footer = '' }

        let validTargets = [];

        if (
            this.props.validTargets &&
            this.props.validTargets.length &&
            this.props.diet &&
            this.props.diet.length
        ) {
            validTargets = this.props.diet
        }

        let opacity = this.getOpacity ();

        let style = { opacity }

        return (
            <section style={style}>
                <header style={style}>
                    {this.props.isProtected === true &&
                        <div style={style} className="card-protection"></div>
                    }
                    <div style={style} className="card-symbol">
                        <span style={style}>{ symbol }</span>
                    </div>
                </header>
                <div style={style} className="card-title">
                    <span style={style}>{this.props.name}</span>
                </div>
                <div style={style} className="card-image"></div>
                <footer>
                    { validTargets.map (this.createPreyIcon) }
                    { this.props.type === Config.types.action &&
                        <div className="card-badge">2</div>
                    }
                    <div className="card-type">
                        <span>{ footer }</span>
                    </div>
                </footer>
            </section>
        )
    }

    getActionDom () {
        let opacity = this.getOpacity ();

        let style = { opacity }

        let validTargets = [];

        let footer = this.props.footer;

        if (this.props.validTargets &&
            this.props.validTargets.length &&
            this.props.diet &&
            this.props.diet.length)
        {
            validTargets = this.props.diet
        }

        // console.clear ()
        // console.log (this.props.name, 'targets:', validTargets)
        let otherTitle = false;

        if (this.props.name !== Config.cards.protectASpecies.name) {
            otherTitle = 'Reduce Carbon Emissions';
            footer = 'Restore 1 Sea Ice';
        }

        if (this.props.name === Config.cards.seaIceRestoration.name) {
            otherTitle = 'Remove Atmospheric Carbon'
            footer = 'Restore 2 Sea Ice';
        }

        return (
            <section style={style}>
                <header style={style}>
                    {this.props.isProtected === true &&
                        <div style={style} className="card-protection"></div>
                    }
                    <div style={style} className="card-symbol">
                        { this.props.symbol }
                    </div>
                </header>
                <div style={style} className="card-title">
                    {otherTitle &&
                        <span>{otherTitle}</span>
                    }
                    <span style={style}>{this.props.name}</span>
                </div>
                <div style={style} className="card-image"></div>
                <div style={style} className="">
                    <div style={style}></div>
                    <div style={style}></div>
                    <div style={style}></div>
                    <div style={style}></div>
                </div>
                <footer>
                    { validTargets.map (this.createPreyIcon) }
                    { this.props.type === Config.types.action &&
                        <div className="card-badge">2 pts</div>
                    }
                    <div className="card-type">
                        <span>{ footer }</span>
                    </div>
                </footer>
            </section>
        )
    }

    render () {
        let cardDom, className;

        if (!this.props.isFaceDown) {
            let type = this.props.type;
            let name = this.props.name;

            if (!type) { type = '' }
            if (!name) { name = '' }

            className = 'card-container ';
            className += Helper.replaceAll (type, ' ', '-').toLowerCase ();
            className += ' ';
            className += Helper.replaceAll (name, ' ', '-').toLowerCase ();
            // className = 'card-container' + ' ' + type.replaceAll (' ', '-').toLowerCase () + ' ' + name.toLowerCase ().replaceAll (' ', '-');

            if (this.props.extraClassNames) {
                className += ' ' + this.props.extraClassNames;
            }

            if (this.props.name === Config.cards.carbonPollution.name) {
                className += ' ' + this.props.img;
            }

            switch (this.props.type) {
                case Config.types.apexPredator:
                    className += ' pm'
                    cardDom = this.getApexPredatorDom ();
                    break;
                case Config.types.lifeform:
                    cardDom = this.getSpeciesDom ();
                    break;
                case Config.types.worldEvent:
                    className += ' ' + this.props.img;
                    cardDom = this.getWorldEventDom ();
                    break;
                case Config.types.action:
                    cardDom = this.getActionDom ();
                    break;
            }

        }
        else {
            className = 'facedown'
            cardDom = (
                <div className="facedown-container">
                    <div className="gradient"> </div>
                    <div className="image"> </div>
                </div>
            )
        }

        let style = {
            position: 'absolute',
            transform: 'translateX(' + this.props.position.x + 'px) translateY(' + this.props.position.y + 'px)',
            zIndex: this.props.zIndex,
            opacity: 1
        }

        if ('opacity ' in this.props) {
            style.opacity = this.props.opacity;
        }

        if (this.props.type === Config.cards.ice.type) {
            delete style.position;
            delete style.transform;
        }

        return (
            <div
                className={className}
                style={style}
                onMouseDown={this.onMouseDown}
                onDblClick={this.onDoubleClick}
                id={this.props.id}
            >
                {cardDom}
            </div>
        )
    }
}
